import { storageEnvTypeOptions } from "../../../../../config/constants";
import { MEASUREMENT_TYPES } from "../../../../../config/enums/MeasurementTypes";
import {
  ENERGY_UNIT_TYPES_OPTIONs,
  POWER_UNIT_TYPES_OPTIONs,
  WEIGHT_UNIT_TYPES_OPTIONs
} from "../../../../../config/optionsConstants";
import { StorageEnvironment } from "../../../../../types/prodcut-data-review/product-data.types";
import { MassUnit } from "../../../../../types/process/process.types";

/**
 * Display labels for every `MEASUREMENT_TYPES` id the Product Review tables render.
 * Superset of {@link MASS_UNIT_MAP} — covers the energy/power/volume ids that the
 * electricity / water / heat columns use in addition to plain mass.
 * The two volume entries are kept as literals: config's own volume label spellings
 * (`VOLUME_UNIT_TYPES_OPTIONs`: "m3 per kg", `WATER_UNIT_TYPES_OPTIONS`: "m3/kg") don't match
 * this table's "m³/kg" formatting, and neither should be forced onto the other.
 */
export const UNIT_LABEL_MAP: Record<number, string> = {
  ...Object.fromEntries(
    [...WEIGHT_UNIT_TYPES_OPTIONs, ...ENERGY_UNIT_TYPES_OPTIONs, ...POWER_UNIT_TYPES_OPTIONs].map(
      o => [o.value, o.text]
    )
  ),
  [MEASUREMENT_TYPES.VOLUME_m3_PER_KG]: "m³/kg",
  [MEASUREMENT_TYPES.VOLUME_m3_PER_TON]: "m³/ton"
};

/** Option list shape `FormUnitInput` / `FormSelect` expect for mass-unit pickers. */
export const MASS_UNIT_OPTIONS = WEIGHT_UNIT_TYPES_OPTIONs.map(o => ({
  value: String(o.value),
  label: o.text
}));

/**
 * Narrowly-typed mass-only view of {@link UNIT_LABEL_MAP}, for the mappers that
 * need the `MassUnit` union rather than a free-form label string. Shared by
 * capacity/input/output/sideStream/waste-distribution unit fields.
 */
export const MASS_UNIT_MAP = Object.fromEntries(
  WEIGHT_UNIT_TYPES_OPTIONs.map(o => [o.value, o.text])
) as Record<number, MassUnit>;

/** Storage-environment id→label map, shared by internal and external storage records. */
export const STORAGE_ENV_MAP = Object.fromEntries(
  storageEnvTypeOptions.map(o => [o.key as number, o.text])
) as Record<number, StorageEnvironment>;
